import React from 'react';

const ContentBody = ({ children, className }) => {
    return <div className={`content-body ${className || ''}`}>{children}</div>;
};

export default ContentBody;
